import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  apiURL,
  formatDate,
} from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import ModalModule from 'gatsby-theme-kn/src/components/modules/ModalModule'
import useModal from 'gatsby-theme-kn/src/hooks/useModal'
import ModalOrderDetail from 'gatsby-theme-kn/src/components/modules/ModalOrderDetail'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const SapServiceDeliveryStatusRouteDetail = ({ routeId, customerNumber }) => {
  const { t } = useTranslation()

  const Fdata = new FormData()
  Fdata.append('delivery_status_route[customer_number]', customerNumber)
  Fdata.append('delivery_status_route[route]', routeId)
  const { data, loading, error } = useAxiosPartnerPortal(apiURL('delivery_status_route'), Fdata, 'post')

  // Modal: Bestell-Detail
  const [modalOrderDetailState, setModalOrderDetailState] = useState(false)
  const closeModalOrderDetail = () => {
    setModalOrderDetailState(false)
  }
  const [modalCustomerNumber, setModalCustomerNumber] = useState(false)
  const [modalWorkOrderNumber, setModalWorkOrderNumber] = useState(false)

  const openModalOrderDetail = (customer_number, work_order_number) => {
    setModalCustomerNumber(customer_number)
    setModalWorkOrderNumber(work_order_number)
    setModalOrderDetailState(true)
  }

  const [modalTitle, setModalTitle] = useState("Auftragspositionen zum Kundenauftrag")

  return (
    <>
      <ModalModule
        isOpen={modalOrderDetailState}
        closeModal={closeModalOrderDetail}
        title={modalTitle}
      >
        <ModalOrderDetail
          customerNumber={modalCustomerNumber}
          workOrderNumber={modalWorkOrderNumber}
          titleSetter={setModalTitle}
        />
      </ModalModule>

      {loading && <LoadingSpinner />}
      {data && (
        <div data-spa-result-for="delivery_status_route" className="mt-1">
          <table className="table table-condensed table-striped">
            <thead>
              <tr>
                {t('generic.spa.results.delivery_status.route_columns').map(
                  (col, index) => (
                    <th key={index} dangerouslySetInnerHTML={{ __html: col }}></th>
                  )
                )}
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => (
                <tr key={index}>
                  <td>
                    <>
                      <a
                        href="#"
                        onClick={() =>
                          openModalOrderDetail(
                            customerNumber,
                            row.auftragsnummer
                          )
                        }
                      >
                        {row.auftragsnummer}
                      </a>
                      <br/>
                      {row.abladestelle}
                      <br/>
                      {row.anlieferzeit}
                    </>
                  </td>
                  <td>
                    <>
                      {row.bestellnummer}
                      <br/>
                      {row.incoterm}
                      <br/>
                      {row.abladehinweis}
                    </>
                  </td>
                  <td>
                    {formatDate(row.lieferdatum)}
                    <br/>
                    {row.lieferpositionen}
                  </td>
                  <td>{row.ladeeinheit}</td>
                  <td>{row.warenempfaenger1}</td>
                  <td>{row.warenempfaenger2}</td>
                  <td>{row.ort}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  )
}

export default SapServiceDeliveryStatusRouteDetail
